export const getTrackingAdImpressions = (tracking, chatId, products) => {
  const {TRACKING_EVENT_NAMES: {AD_IMPRESSIONS_COLLECTED_EVENT} = {}} = tracking || {}

  return {
    event: AD_IMPRESSIONS_COLLECTED_EVENT,
    data: {
      hit_information: chatId,
      products
    }
  }
}
